/**
 * @module app.pp
 * @preferred
 */

import { autoinject, Container, PLATFORM } from 'aurelia-framework';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { AppModule, DynamicViews, MemberFilters, IMemberFilter } from 'app/shared/config/modules';
import { IAppRouteConfig } from 'app/shared/config/router-types';
import { AuthPortalPageContext } from 'app/pp/lib/auth-portal-page-context';
import { AuthContext } from 'app/um/lib/auth-context';

@autoinject()
export class ProviderPortalModule extends AppModule {

    public readonly code = 'pp';
    public readonly memberFilters: IMemberFilter[] = [];

    constructor(private readonly logger: AppLogger, memberFilters: MemberFilters, container: Container) {
        super();

        logger.source = this;

        memberFilters.registerFilters(this.memberFilters);

        container.registerAlias(AuthPortalPageContext, AuthContext);
    }

    public getTranslationNamespaces(): ReadonlyArray<string> {
        return ['pp'];
    }

    public getRoutes(): ReadonlyArray<IAppRouteConfig> {
        return [
            { route: 'admin/users', name: 'pp.admin.users', moduleId: PLATFORM.moduleName('app/pp/pages/admin/users-page'), title: 'pp.admin.users', activationStrategy: 'invoke-lifecycle', settings: { topic: 'pp.manage-proxies' } },
            { route: 'pp/patients/search', name: 'pp.members.search', moduleId: PLATFORM.moduleName('app/pp/pages/patient-search-page'), title: 'pp.member.search', activationStrategy: 'invoke-lifecycle', settings: { topic: 'pp.patient-search' } },
            { route: 'pp/member/:memberId/summary', name: 'pp.patient.summary', moduleId: PLATFORM.moduleName('app/pp/pages/patient-summary-page'), title: 'pp.member.summary', activationStrategy: 'invoke-lifecycle', settings: { topic: 'pp.patient-summary' } },
            { route: 'my-todo-list', name: 'pp.my-todo-list', moduleId: PLATFORM.moduleName('app/pp/pages/my-todo-page'), title: 'pp.my-todo-list', activationStrategy: 'invoke-lifecycle', settings: { topic: 'pp.my-todo-list' } },
            { route: 'tasks/:taskId', name: 'pp.task', moduleId: PLATFORM.moduleName('app/pp/pages/tasks/task-details-page'), title: 'pp.task', activationStrategy: 'invoke-lifecycle', settings: { topic: 'pp.task' } },
            { route: 'interventions/:interventionId', name: 'pp.intervention', moduleId: PLATFORM.moduleName('app/pp/pages/tasks/intervention-details-page'), title: 'pp.intervention', activationStrategy: 'invoke-lifecycle', settings: { topic: 'pp.intervention' } },
            { route: 'cd/providers/contacts', name: 'pp.providers.contacts', moduleId: PLATFORM.moduleName('app/pp/pages/admin/contact-page'), title: 'pp.provider.contacts', activationStrategy: 'invoke-lifecycle', settings: { topic: 'pp.manage-contacts' } },
            { route: 'auths/create', name: 'pp.auths.create', moduleId: PLATFORM.moduleName('app/pp/pages/auths/create-page'), title: 'pp.auths.create', activationStrategy: 'replace', settings: { topic: 'pp.auth-create' } },
            { route: 'auths/search', name: 'pp.auths.search', moduleId: PLATFORM.moduleName('app/pp/pages/auths/search-page'), title: 'pp.auths.search', activationStrategy: 'invoke-lifecycle', settings: { topic: 'pp.my-auths' } },
            { route: 'pp/auth/:authId/summary', name: 'pp.auth.summary', moduleId: PLATFORM.moduleName('app/um/pages/summary/auth-summary-page'), title: 'pp.auth.summary', activationStrategy: 'invoke-lifecycle', settings: { topic: 'pp.auth-summary' } }
        ];
    }

    public getDynamicViews(scope: string): DynamicViews {

        return {};
    }
}
